import { render, staticRenderFns } from "./UserBar.vue?vue&type=template&id=3b39b7e4&"
import script from "./UserBar.vue?vue&type=script&lang=ts&"
export * from "./UserBar.vue?vue&type=script&lang=ts&"
import style0 from "./UserBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports